import "./styles.scss";

import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";

import PhotoAvatar from "../../PhotoAvatar";

function ModalProfilePicture({ showModal, setShowModal }) {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const [picture, setPicture] = useState(null);

  useEffect(() => {
    if (user?.picture) setPicture(user?.picture);
    // eslint-disable-next-line
  }, []);

  return (
    <Dialog
      open={showModal}
      className="modalPrivilege"
      classes={"modalProfilePicture"}
      onClose={() => setShowModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerProfilePicture">
        <h3 className="title">{t("PROFILE_PICTURE")}</h3>
        <form className="contentProfilePicture">
          {!picture ? (
            <form>
              <PhotoAvatar userID={user?.id} picture={picture} setPicture={setPicture} />
            </form>
          ) : (
            <h4>{t("SUCCESS_MESSAGE_PHOTO")}</h4>
          )}
        </form>

        <div className="footer">
          <button className="buttonModalSave" onClick={() => setShowModal(false)}>
            {t("BTN_CLOSE")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalProfilePicture;
